const resetMessageUtil = (field, defaultMessage, formik) =>
  formik.setFieldValue(
    field,
    defaultMessage ||
      'Failed to get default message from server. Try again later.'
  );

export default resetMessageUtil;
